import React, { Component } from 'react';
import { Form, Modal, Button, Divider, Table, Tabs, Input,DatePicker } from 'antd';
import moment from 'moment';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import ImageView from '../../ui/ImageView';
import PdfView from '../../ui/PdfView'
import './contractManage.css';
import { global_data } from '../../ui/auth'

//  项目及商家信息
const projectInfo = [{
    "text": "项目名称",
    "field": "buildingName",
}, {
    "text": "合同文本号",
    "field": "code",
}, {
    "text": "意向商户",
    "field": "clientName",
}, {
    "text": "经营类别及范围",
    "field": "businessCategory",
}, {
    "text": "经营业态",
    "field": "businessDetail",
}, {
    "text": "签约方",
    "field": "signatory",
}, {
    "text": "联系人",
    "field": "partybContactInfo.name"
}, {
    "text": "电话",
    "field": "partybContactInfo.tel",
}, {
    "text": "邮箱",
    "field": "partybContactInfo.mail",
}, {
    "text": "地址",
    "field": "partybContactInfo.address"
}, {
    "text": "银行账号",
    "field": "partybAccount.bankAccount"
}, {
    "text": "账号名称",
    "field": "partybAccount.accountName"
}, {
    "text": "开户行",
    "field": "partybAccount.bankName"
}];

//  商务基本信息
const contractInfo = [{
    "text": "租赁区域",
    "field": "berthIdsStr",
}, {
    "text": "铺位类型",
    "field": "berthType",
}, {
    "text": "铺位面积",
    "field": "rentArea",
    'rentArea': true
}, {
    "text": "计租面积",
    "field": "buildingArea",
}, {
    "text": "交付日期",
    "field": "deliveryDate",
}, {
    "text": "合同起始日期",
    "field": "rentStartDate",
}, {
    "text": "合同结束日期",
    "field": "rentEndDate",
}, {
    "text": "合同期（个月）",
    "field": "leaseMonth",
}, {
    "text": "计租起始日期",
    "field": "rentalStartDate",
}, {
    "text": "计租结束日期",
    "field": "rentalEndDate",
}, {
    "text": "开业日期",
    "field": "openDate",
}, {
    "text": "免租期（个月）",
    "field": "freeMonth",
}
];

// 其他项目信息
const otherItem = [
    {
        "text": "物业费支付周期",
        "field": "propertyFeeCycleStr",
    }
    ,{
        "text": "水电费每期减免",
        "field": "busiManageContractVO.reduceWeFees",
    }
    ,{
        "text": "推广服务费(元/月.㎡)",
        "field": "busiManageContractVO.promotionFeeUnit",
    }
    ,{
        "text": "履约保证金(元)",
        "field": "leaseDeposit1Fee",
    }
]

const rentItem = [
    {
        "text": "租金方式",
        "field": "rentType",
    }, {
        "text": "租金支付周期",
        "field": "paymentCycleStr",
    }
]
//广告费
const advertiseInfo = [{
    "text": "合同开始日期",
    "field": "advertiseStartDate",
    rangeDate: true
}
,{
    "text": "合同结束日期",
    "field": "advertiseEndDate",
    rangeDate: true
}
,{
    "text": "收费标准",
    "field": "advertiseFee",
    "integer": true
}
,{
    "text": "广告费支付周期",
    "field": "advertiseFeeCycleStr",
    "select": true,
    category: "berth_advertise_pay_cycle"
}
]
//停车费
const barrierInfo = [{
    "text": "合同开始日期",
    "field": "barrierStartDate",
    rangeDate: true
}
,{
    "text": "合同结束日期",
    "field": "barrierEndDate",
    rangeDate: true
}
,{
    "text": "收费标准",
    "field": "barrierFee",
    "integer": true
}
,{
    "text": "停车费支付周期",
    "field": "barrierFeeCycleStr",
    "select": true,
    category: "berth_barrier_pay_cycle"
}
]

const contractLogColumns = [{
    title: '操作人',
    dataIndex: 'operator',
    width: '20%',
}, {
    title: '操作时间',
    dataIndex: 'insertTime',
    width: '20%',
}, {
    title: '状态',
    dataIndex: 'type',
    width: '20%',

}, {
    title: '备注',
    dataIndex: 'remark',
    width: '20%',
},{
    title: '退租时间',
    dataIndex: 'finishDate',
    width: '20%',
}]

const tenantFeesList = [{
    title: '账单编号 ',
    dataIndex: 'id',
    width: '10%',
}, {
    title: '账期 ',
    dataIndex: 'month',
    width: '10%',
}
, {
    title: '租金金额',
    dataIndex: 'totalRentFees',
    width: '10%',
}
, {
    title: '管理费金额',
    dataIndex: 'totalPropertyFees',
    width: '10%',
}
, {
    title: '水费金额',
    dataIndex: 'totalWaterFees',
    width: '10%',
}
, {
    title: '电费金额',
    dataIndex: 'totalElectricityFees',
    width: '10%',
}
, {
    title: '账单总金额',
    dataIndex: 'totalFees',
    width: '10%',
}
, {
    title: '付款状态',
    dataIndex: 'status',
    width: '10%',
    render: (text, record, index) => (
        <div>
            {
                record.status === 2 ? <span style={{ color: 'green' }}>已付</span> : <span style={{ color: 'red' }}>未付</span>
            }
        </div>
    ),
}
];

class ContractManageDetail extends Component {

    leaseColumns = [{
        title: '租赁年度',
        dataIndex: 'year',
        width: '13%'
    }, {
        title: "租金标准(元/㎡/月)",
        dataIndex: 'planRentPerUnit',
        width: '12%',
    }, {
        title: "标准年租金(元)",
        dataIndex: 'yearPlanRent',
        width: '15%'
    }, {
        title: '申请租金(元/㎡/月)',
        dataIndex: 'rentPerUnit',
        width: '15%',
    }, {
        title: '申请年租金(元)',
        dataIndex: 'yearRent',
        width: '15%',
    }, {
        title: '每年总租金差异额(元)',
        dataIndex: 'yearRentDiff',
        width: '15%',
    }, {
        title: '每年总租金达成率',
        dataIndex: 'yearRentRate',
        width: '15%'
    }, {
        title: '免租期（月）',
        dataIndex: 'freeMonth',
        width: '10%'
    }];

    busiColumns = [{
        title: '租赁年度',
        dataIndex: 'year',
        width: '13%'
    }, {
        title: "标准物管费(元/㎡/月)",
        dataIndex: 'planRentPerUnit',
        width: '12%',
    }, {
        title: "标准年物管费(元)",
        dataIndex: 'yearPlanRent',
        width: '15%'
    }, {
        title: '申请物管费(元/㎡/月)',
        dataIndex: 'rentPerUnit',
        width: '15%',
    }, {
        title: '申请年物管费(元)',
        dataIndex: 'yearRent',
        width: '15%',
    }, {
        title: '每年总物管费差异额(元)',
        dataIndex: 'yearRentDiff',
        width: '15%',
    }, {
        title: '每年总物管费达成率',
        dataIndex: 'yearRentRate',
        width: '15%'
    }];

    state = {
        image: null,
        previewVisible: false,
        previewImage: null,
        activeKey: 'shops',
        pdfVisible: false,
        rejectVisible: false,
        auditedVisible: false,
        auditUrl: "/market/contract/audited",
        rejectUrl: "/market/contract/reject",
        rentStandardList: [],
        busiFeeStandardList: [],
        finishDate:""
    }

    componentDidMount() {
        // let clientW = document.body.clientWidth
        // let clientH = document.body.clientHeight
        if (this.props.initDetail) {
            this.props.initDetail(this.initDetail);
        }
        let clientW = window.screen.width
        let clientH = window.screen.height

        this.setState({
            clientW: clientW,
            clientH: clientH
        })
    }

    initDetail = (rentStandardList, busiFeeStandardList, berthIds, freeMonth) => {
        if (berthIds && berthIds !== "") {
            let berthIdArray = berthIds.split(",");
            http.get({
                url: "/berth/findBerthRentByBerthIds",
                data: { berthIds: berthIds },
                success: (res) => {
                    //初始化租金表格数据
                    this.initRentTableData(rentStandardList, berthIdArray, res, freeMonth);
                    //初始化物管费表格数据
                    this.initBussTableData(busiFeeStandardList, berthIdArray, res);
                    this.setState({
                        rentStandardList: rentStandardList,
                        busiFeeStandardList: busiFeeStandardList,
                        berthIds: berthIds,
                        berthInfoMap: res
                    });
                }
            });
        }
    }

    /**
     * 初始化租金表格数据
     * @param dataList 表格数据，表格数据中包括每个时间段的起始时间和结束时间
     * @param berthIdArray 选中的商铺id（整数）数组
     * @param rentStandardMap 商铺每年的标准租金数据map，key为商铺id，value为商铺面积和商铺每年标准租金列表
     * @param freeMonth 免租月份
     */
    initRentTableData = (dataList, berthIdArray, rentStandardMap, freeMonth) => {
        //年标准年租金总和
        let yearPlanRentSum = 0;
        //年租金总和
        let yearRentSum = 0;
        dataList.forEach((item, index) => {
            item["index"] = index;
            item["year"] = "第" + (index + 1) + "年";
            //设置第index+1年的月租金标准
            let planRentMonthStart = 0;
            let planRentMonthEnd = 0;
            let start = moment(item.rentStartDate);
            let startYear = start.year() + "";
            let startMonth = 12 - start.month();
            let end = moment(item.rentEndDate).add(1, "days");
            let endYear = end.year() + "";
            let endMonth = end.month();
            let totalBerthArea = 0;
            berthIdArray.forEach(berthId => {
                let berthInfo = rentStandardMap[berthId];
                if (berthInfo) {
                    //计算商铺总面积
                    totalBerthArea += berthInfo.buildingArea;
                    let berthRentList = berthInfo["rentList"];
                    if (berthRentList && berthRentList.length > 0) {
                        berthRentList.forEach(rent => {
                            if (rent.year === startYear) {
                                planRentMonthStart += rent.rent * berthInfo.buildingArea;
                            }
                            if (rent.year === endYear) {
                                planRentMonthEnd += rent.rent * berthInfo.buildingArea;
                            }
                        });
                    }
                }
            });

            //应该支付租金的月数
            let payMonth = end.diff(start, "months");
            //如果没有跨年
            if (startYear === endYear) {
                //计算年标准租金
                item["yearPlanRent"] = parseFloat((planRentMonthStart * payMonth).toFixed(2));
                //月租金除以总面积就是标准单位租金
                item["planRentPerUnit"] = (planRentMonthStart / totalBerthArea).toFixed(2);
            }
            else {
                //计算年标准租金
                item["yearPlanRent"] = parseFloat((planRentMonthStart * startMonth + planRentMonthEnd * endMonth).toFixed(2));
                //如果租期跨年，需要累计计算第一年和第二年的标准租金，再除以月数才是这个租期内的标准单位租金
                item["planRentPerUnit"] = (item["yearPlanRent"] / (payMonth * totalBerthArea)).toFixed(2);
            }

            //默认免租期分到每年
            if (index >= 0 && freeMonth) {
                //扣除免租期的月数
                payMonth = payMonth - 1;
            }
            let rentPerUnit = item["rentPerUnit"] ? item["rentPerUnit"] : 0;
            item["yearRent"] = parseFloat((rentPerUnit * payMonth * totalBerthArea).toFixed(2));
            item["yearRentDiff"] = (item["yearRent"] - item["yearPlanRent"]).toFixed(2);
            if (item["yearPlanRent"] === 0) {
                item["yearRentRate"] = 0;
            }
            else {
                item["yearRentRate"] = (item["yearRent"] / item["yearPlanRent"] * 100).toFixed(2) + "%";
            }
            item["freeMonth"] = index >=freeMonth?0:1;
            //月租金
            item["rental"] = rentPerUnit * totalBerthArea;
            yearPlanRentSum += item["yearPlanRent"];
            yearRentSum += item["yearRent"];
        });
        //设置总结数据
        if (dataList.length !== 0) {
            let lastItem = {};
            lastItem["index"] = dataList.length;
            lastItem["year"] = "租金合计(元)";
            lastItem["planRentPerUnit"] = "/";
            lastItem["rentPerUnit"] = "/";
            lastItem["yearPlanRent"] = yearPlanRentSum.toFixed(2);
            lastItem["yearRent"] = yearRentSum.toFixed(2);
            lastItem["yearRentDiff"] = (yearRentSum - yearPlanRentSum).toFixed(2);
            if (yearPlanRentSum === 0) {
                lastItem["yearRentRate"] = 0;
            }
            else {
                lastItem["yearRentRate"] = (yearRentSum / yearPlanRentSum * 100).toFixed(2) + "%";
            }
            lastItem["freeMonth"] = freeMonth;

            dataList.push(lastItem);
        }
    }

    /**
     * 初始化物管费表格数据
     * @param dataList 表格数据，表格数据中包括每个时间段的起始时间和结束时间
     * @param berthIdArray 选中的商铺id（整数）数组
     * @param rentStandardMap 商铺每年的标准租金数据map，key为商铺id，value为商铺面积等数据
     */
    initBussTableData = (dataList, berthIdArray, rentStandardMap) => {
        //年标准物管费总和
        let yearPlanRentSum = 0;
        //年物管费总和
        let yearRentSum = 0;
        dataList.forEach((item, index) => {
            item["year"] = "第" + (index + 1) + "年";
            item["index"] = index;
            let start = new moment(item.rentStartDate);
            let end = (new moment(item.rentEndDate)).add(1, "days");
            //累计选中的商铺总面积
            let totalBerthArea = 0;
            //每月的物业费
            let monthPropertyCost = 0;
            berthIdArray.forEach(berthId => {
                let berthInfo = rentStandardMap[berthId];
                if (berthInfo) {
                    //计算商铺总面积
                    totalBerthArea += berthInfo.buildingArea;
                    monthPropertyCost += berthInfo.propertyCost * berthInfo.buildingArea;
                }
            });
            //应该支付物管费的月数
            let payMonth = end.diff(start, "months");
            //计算年标准物业费 = 每月物业费 * 应支付月数
            item["yearPlanRent"] = parseFloat((monthPropertyCost * payMonth).toFixed(2));
            item["planRentPerUnit"] = (monthPropertyCost / totalBerthArea).toFixed(2);
            let rentPerUnit = item["rentPerUnit"] ? item["rentPerUnit"] : 0;
            item["yearRent"] = parseFloat((rentPerUnit * payMonth * totalBerthArea).toFixed(2));
            item["yearRentDiff"] = (item["yearRent"] - item["yearPlanRent"]).toFixed(2);
            if (item["yearPlanRent"] === 0) {
                item["yearRentRate"] = 0;
            }
            else {
                item["yearRentRate"] = (item["yearRent"] / item["yearPlanRent"] * 100).toFixed(2) + "%";
            }
            //月租金
            item["rental"] = rentPerUnit * totalBerthArea;
            yearPlanRentSum += item["yearPlanRent"];
            yearRentSum += item["yearRent"];
        });
        //设置总结数据
        if (dataList.length !== 0) {
            let lastItem = {};
            lastItem["index"] = dataList.length;
            lastItem["year"] = "物管费合计(元)";
            lastItem["planRentPerUnit"] = "/";
            lastItem["rentPerUnit"] = "/";
            lastItem["yearPlanRent"] = yearPlanRentSum.toFixed(2);
            lastItem["yearRent"] = yearRentSum.toFixed(2);
            lastItem["yearRentDiff"] = (yearRentSum - yearPlanRentSum).toFixed(2);
            if (yearPlanRentSum === 0) {
                lastItem["yearRentRate"] = 0;
            }
            else {
                lastItem["yearRentRate"] = (yearRentSum / yearPlanRentSum * 100).toFixed(2) + "%";
            }
            dataList.push(lastItem);
        }
    }

    creaateDetailTable = (data) => {
        const { detailData } = this.props;
        let dom = [];
        let tdNum = 3;
        for (let i = 0; i < data.length; i += tdNum) {
            let td = [];
            for (let j = 0; j < tdNum && (i + j) < data.length; j++) {
                let text = (<td key={"td" + i + j}>{data[i + j]["text"] + "："}</td>);
                let colSpan = 1;
                if ((i + j) === (data.length - 1)) {
                    colSpan = (tdNum - j) * 2 - 1;
                }
                let field = (<td key={"td" + i + j + 1} colSpan={colSpan}>{detailData[data[i + j]["field"]]}</td>);
                td.push(text);
                td.push(field);
            }
            let tr = (<tr key={"tr" + i}>{td}</tr>);
            dom.push(tr);
        }
        let table = (
            <table className="contract-detail-table">
                <tbody>
                    {dom}
                </tbody>
            </table>
        );
        return table;
    }

    // 退回
    rejectFunc = (type) => {
        if (type === "merchants") {
            this.setState({
                rejectVisible: true,
                rejectUrl: "/market/contract/merchants/reject"
            })
        }
        else if (type === "finance") {
            this.setState({
                rejectVisible: true,
                rejectUrl: "/market/contract/finance/reject"
            })
        }
        else if(type === "manager"){
            this.setState({
                rejectVisible: true,
                rejectUrl: "/market/contract/reject"
            })
        }else if(type === "finishMerchants"){
            //招商经理拒绝退租
            const { detailData } = this.props;
            this.setState({
                rejectVisible: true,
                rejectUrl: "/market/contract/merchants/finishReject",
                finishDate:detailData.contractLogList[0].finishDate
            })
        }else if(type === "finishFinance"){
            //财务经理拒绝退租
            const { detailData } = this.props;
            this.setState({
                rejectVisible: true,
                rejectUrl: "/market/contract/finance/finishReject",
                finishDate:detailData.contractLogList[0].finishDate
            })
        }else if(type === "finishManager"){
            //总经理拒绝退租
            const { detailData } = this.props;
            this.setState({
                rejectVisible: true,
                rejectUrl: "/market/contract/finishReject",
                finishDate:detailData.contractLogList[0].finishDate
            })
        }
    }


    // 审核通过
    audited = (type) => {
        if (type === "merchants") {
            this.setState({
                auditedVisible: true,
                auditUrl: "/market/contract/merchants/audited"
            })
        }
        else if (type === "finance") {
            this.setState({
                auditedVisible: true,
                auditUrl: "/market/contract/finance/audited"
            })
        }
        else if(type === "manager"){
            this.setState({
                auditedVisible: true,
                auditUrl: "/market/contract/audited"
            })
        }else if(type==="finish"){
            const { detailData } = this.props;
            //退租申请
            this.setState({
                auditedVisible: true,
                auditUrl: "/market/contract/finishCommit",
                finishDate:detailData.contractLogList[0].finishDate
            })
        }else if(type==="finishMerchants"){
            //招商经理同意退租
            const { detailData } = this.props;
            this.setState({
                auditedVisible: true,
                auditUrl: "/market/contract/merchants/finishAudited",
                finishDate:detailData.contractLogList[0].finishDate
            })
        }else if(type==="finishFinance"){
            //财务经理同意退租
            const { detailData } = this.props;
            this.setState({
                auditedVisible: true,
                auditUrl: "/market/contract/finance/finishAudited",
                finishDate:detailData.contractLogList[0].finishDate
            })
        }else if(type==="finishManager"){
            //总经理同意退租
            const { detailData } = this.props;
            this.setState({
                auditedVisible: true,
                auditUrl: "/market/contract/finishAudited",
                finishDate:detailData.contractLogList[0].finishDate
            })
        }
    }
    hiddenauditedModal = () => {
        this.setState({
            auditedVisible: false
        })
    }
    previewPdf = (type) => {
        this.setState({ loadingVisible: true })
        const { detailData } = this.props;
        let url = '';
        let fileName = '';
        if (type === 'LeaseContract') {
            url = '/market/contract/download/downloadLeaseContract'
            fileName = detailData.clientName + "  商铺租赁合同.pdf"
        } else if (type === 'BusiContract') {
            url = '/market/contract/download/downloadBusiContract'
            fileName = detailData.clientName + "  商业管理服务合同.pdf"
        }

        this.setState({ pdfVisible: true })
        setTimeout(() => {
            let view = this.refs["pdfView"];
            view.loadFile({
                url: url,
                fileName: fileName,
                data: { "id": detailData.id },
                saveFile: false,
            });
        })
        this.setState({ loadingVisible: false })
    }
    hiddenPdflModal = () => {
        this.setState({
            pdfVisible: false,
        })
    }
    hiddenRejectlModal = () => {
        this.setState({ rejectVisible: false })
    }
    doFailSuccess = () => {
        const { successCallback, queryData, onCancel } = this.props;
        onCancel();
        successCallback(queryData);
    }

    render() {
        const { visible, onCancel, detailData, codeList } = this.props;
        let { busiFeeStandardList, rentStandardList } = this.state;
        busiFeeStandardList.forEach((item, index) => { item.index = index });
        rentStandardList.forEach((item, index) => { item.index = index });
        let footer = []
        if (codeList !== undefined) {
            footer = [
                codeList.includes('CONTRACT_MANAGE_M_AUDIT') && detailData.status === 'COMMIT' ? <Button key="CONTRACT_MANAGE_M_AUDITED" type="primary" onClick={this.audited.bind(this, "merchants")}>通过</Button> : "",
                codeList.includes('CONTRACT_MANAGE_M_REJECT') && detailData.status === 'COMMIT' ? <Button key="'CONTRACT_MANAGE_M_REJECT" type="danger" onClick={this.rejectFunc.bind(this, "merchants")}>退回</Button> : "",
                codeList.includes('CONTRACT_MANAGE_F_AUDITED') && detailData.status === 'MERCHANTS_AUDITED' ? <Button key="CONTRACT_MANAGE_F_AUDITED" type="primary" onClick={this.audited.bind(this, "finance")}>通过</Button> : "",
                codeList.includes('CONTRACT_MANAGE_F_REJECT') && detailData.status === 'MERCHANTS_AUDITED' ? <Button key="'CONTRACT_MANAGE_F_REJECT" type="danger" onClick={this.rejectFunc.bind(this, "finance")}>退回</Button> : "",
                codeList.includes('CONTRACT_MANAGE_AUDIT') && detailData.status === 'FINANCE_AUDITED' ? <Button key="CONTRACT_MANAGE_AUDIT" type="primary" onClick={this.audited.bind(this,"manager")}>通过</Button> : "",
                codeList.includes('CONTRACT_MANAGE_REJECT') && detailData.status === 'FINANCE_AUDITED' ? <Button key="'CONTRACT_MANAGE_REJECT" type="danger" onClick={this.rejectFunc.bind(this,"manager")}>退回</Button> : "",
                //退租相关按钮
                global_data.authCode.includes("CONTRACT_FINISH_COMMIT")&& (detailData.status === 'AUDITED'||detailData.status === 'FINISH_MERCHANTS_REJECT'||detailData.status === 'FINISH_FINANCE_REJECT'||detailData.status === 'FINISH_REJECT'||detailData.status === 'FINISH_AUDITED') ? <Button key="CONTRACT_MANAGE_M_AUDITED" type="primary" onClick={this.audited.bind(this, "finish")}>申请退租</Button> : "",                
                global_data.authCode.includes('CONTRACT_FINISH_MANAGE_M_AUDIT') && detailData.status === 'FINISH_COMMIT' ? <Button key="CONTRACT_MANAGE_M_AUDITED" type="primary" onClick={this.audited.bind(this, "finishMerchants")}>退租通过</Button> : "",
                global_data.authCode.includes('CONTRACT_FINISH_MANAGE_M_REJECT') && detailData.status === 'FINISH_COMMIT' ? <Button key="'CONTRACT_MANAGE_M_REJECT" type="danger" onClick={this.rejectFunc.bind(this, "finishMerchants")}>退租退回</Button> : "",
                global_data.authCode.includes('CONTRACT_FINISH_MANAGE_F_AUDITED') && detailData.status === 'FINISH_MERCHANTS_AUDITED' ? <Button key="CONTRACT_MANAGE_F_AUDITED" type="primary" onClick={this.audited.bind(this, "finishFinance")}>退租通过</Button> : "",
                global_data.authCode.includes('CONTRACT_FINISH_MANAGE_F_REJECT') && detailData.status === 'FINISH_MERCHANTS_AUDITED' ? <Button key="'CONTRACT_MANAGE_F_REJECT" type="danger" onClick={this.rejectFunc.bind(this, "finishFinance")}>退租退回</Button> : "",
                global_data.authCode.includes('CONTRACT_FINISH_MANAGE_AUDIT') && detailData.status === 'FINISH_FINANCE_AUDITED' ? <Button key="CONTRACT_MANAGE_AUDIT" type="primary" onClick={this.audited.bind(this,"finishManager")}>退租通过</Button> : "",
                global_data.authCode.includes('CONTRACT_FINISH_MANAGE_REJECT') && detailData.status === 'FINISH_FINANCE_AUDITED' ? <Button key="'CONTRACT_MANAGE_REJECT" type="danger" onClick={this.rejectFunc.bind(this,"finishManager")}>退租退回</Button> : ""            
            ]
        }

        if (this.props.type === '1') {
            footer = []
        }
        return (
            <div>
                <Modal
                    width={1250}
                    visible={visible}
                    title={<div style={{ width: '100%', textAlign: 'center', fontSize: "22px" }}>由招商营运部发起的合同审批</div>}
                    okText="确定"
                    cancelText="取消"
                    maskClosable={false}
                    onCancel={onCancel}
                    onOk={this.print}
                    zIndex={1000}
                    footer={[
                        footer,
                        <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                    ]}
                    afterClose={() => {
                        this.setState({ activeKey: 'shops' })
                    }}
                >
                    <div>
                        <Tabs tabPosition='left' activeKey={this.state.activeKey}
                            onChange={(activeKey) => {
                                this.setState({ activeKey: activeKey });
                            }}
                        >
                            <Tabs.TabPane tab="商铺租赁合同" key="shops">
                                <div style={{ float: 'right' }}>
                                    <Button type='primary' onClick={this.previewPdf.bind(this, 'LeaseContract')}>商铺租赁合同预览</Button>
                                    <Button type='primary' style={{ marginLeft: 20 }} onClick={this.previewPdf.bind(this, 'BusiContract')}>商业管理服务合同预览</Button>
                                </div>

                                <Divider orientation="left" style={{ marginTop: 0 }}>项目及商家信息</Divider>
                                {this.creaateDetailTable(projectInfo)}
                                <Divider orientation="left" style={{ marginTop: 0 }}>商务基本信息</Divider>
                                {this.creaateDetailTable(contractInfo)}
                                <Divider orientation="left" style={{ marginTop: 0 }}>租金收费标准</Divider>
                                <Table rowKey="index" columns={this.leaseColumns} dataSource={rentStandardList} tableLayout="fixed" pagination={false} bordered={true} style={{ marginBottom: "10px" }} />
                                {this.creaateDetailTable(rentItem)}
                                <Divider orientation="left" style={{ marginTop: 0 }}>物管收费标准</Divider>
                                <Table rowKey="index" columns={this.busiColumns} dataSource={busiFeeStandardList} tableLayout="fixed" pagination={false} bordered={true} style={{ marginBottom: "10px" }} />
                                {this.creaateDetailTable(otherItem)}
                                <Divider orientation="left" style={{ marginTop: 0 }}>广告费</Divider>
                                {this.creaateDetailTable(advertiseInfo)}
                                <Divider orientation="left" style={{ marginTop: 0 }}>停车费</Divider>
                                {this.creaateDetailTable(barrierInfo)}

                            </Tabs.TabPane>
                            {this.props.detailData.tenantFeesList!==undefined ? <Tabs.TabPane tab="账单列表" key="tenantFeesList">
                                {/* {this.creaateDetailTable(billList)} */}
                                <div style={{ fontSize: 18, marginBottom: 20 }}>账单总共：
                            <span style={{ color: 'red' }}>{detailData["tenantFeesList"] == null ? "" : detailData["tenantFeesList"].length}</span>期，账单总金额：
                            <span style={{ color: 'red' }}>{detailData['allMoney']}</span>元，已付金额：
                            <span style={{ color: 'red' }}>{detailData['payMoney']}</span>元，完成比例：
                            <span style={{ color: 'red' }}>{detailData['payProportion']}%</span></div>
                                <Table rowKey="id"
                                    columns={tenantFeesList}
                                    dataSource={detailData["tenantFeesList"] == null ? [] : detailData["tenantFeesList"]}
                                    pagination={false}
                                    style={{ border: '1px solid #e8e8e8', borderBottom: 0 }}
                                // rowClassName={(record, index) => record.status ==='1'?'tableRed':'tableGreen'}
                                />
                            </Tabs.TabPane> : ''}

                            <Tabs.TabPane tab="操作日志" key="doLog">
                                <Divider orientation="left">操作日志</Divider>
                                {/* {this.creaateDetailTable(busiRentColumns)} */}
                                <Table rowKey="id"
                                    columns={contractLogColumns}
                                    dataSource={detailData["contractLogList"] == null ? [] : detailData["contractLogList"]}
                                    pagination={false}
                                    style={{ border: '1px solid #e8e8e8', borderBottom: 0 }}
                                />
                            </Tabs.TabPane>
                        </Tabs>

                    </div>
                    <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} />
                </Modal>
                <Modal
                    width={1250}
                    visible={this.state.pdfVisible}
                    title="合同预览"
                    okText="确定"
                    cancelText="取消"
                    maskClosable={false}
                    onCancel={this.hiddenPdflModal}
                    onOk={this.print}
                    zIndex={1000}
                    footer={[
                        footer,
                        <Button key="cancel" type="default" onClick={this.hiddenPdflModal}>关闭</Button>
                    ]}
                >
                    {
                        this.state.pdfVisible ?
                            // <div style={{ position: 'absolute', top: '50%', left: '50%', zIndex: 1111, transform: ' translate(-50%, -50%)' }}>
                            // <div style={{ height: this.state.clientH - 200, width:'700px', background: '#525659' }} >
                            <div >
                                <div style={{ height: '700px', width: '1200px', background: '#525659' }} >
                                    <div style={{
                                        color: '#333',
                                        background: '#ffffff',
                                        width: '100%',
                                        textAlign: 'right',
                                        paddingRight: 30,
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        fontSize: 20,
                                    }}
                                    >
                                        {/* <span onClick={this.hiddenPdflModal} style={{ cursor: 'pointer' }}>X</span> */}
                                    </div>
                                    <PdfView ref="pdfView" />
                                </div>
                            </div> : ''
                    }
                </Modal>
                <ContractAuditSuccess
                    visible={this.state.auditedVisible}
                    onCancel={this.hiddenauditedModal.bind(this)}
                    detailData={detailData}
                    successCallback={this.doFailSuccess}
                    url={this.state.auditUrl}
                    finishDate={this.state.finishDate}
                />
                <ContractAuditFail
                    visible={this.state.rejectVisible}
                    onCancel={this.hiddenRejectlModal.bind(this)}
                    detailData={detailData}
                    successCallback={this.doFailSuccess}
                    url={this.state.rejectUrl}
                    finishDate={this.state.finishDate}
                />
            </div>
        );
    }
}

class ContractAuditSuccessForm extends Component {
    state={
        finishDate:""
    }
    componentWillMount() {
        const {finishDate} = this.props
        this.setState({
            finishDate:finishDate
        })
    }
    failContract = () => {
        const form = this.props.form;
        const { detailData, url,finishDate} = this.props
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["id"] = detailData.id;
            if(this.state.finishDate!==""){
                values["finishDate"]=this.state.finishDate
            }else{
                values["finishDate"]=finishDate
            }
            // return;
            http.post({
                url: url,
                data: { ...values },
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("审核通过！");
                }
            });
        });
    }

    onDateChange = (item, val) => {
        this.setState({
            finishDate:val
        })
    };

    render() {
        const { detailData,visible, onCancel, form,finishDate } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="审核意见"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.failContract}
                zIndex={1001}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                    {detailData.status==='COMMIT'||detailData.status==='MERCHANTS_AUDITED'||detailData.status==='FINANCE_AUDITED'
                    ||detailData.status==='FINISH_COMMIT'||detailData.status==='FINISH_MERCHANTS_AUDITED'||detailData.status==='FINISH_FINANCE_AUDITED'
                    ?
                    <Form.Item label="审核意见：">
                        {getFieldDecorator('remark', {
                            rules: [{ max: 256, message: '最多只能输入256个字符！' }],
                        })(
                            <Input.TextArea />
                        )}
                    </Form.Item>
                    :""}
                    {/* 退租流程才显示日期 */}
                    {detailData.status==='AUDITED'||detailData.status==='FINISH_COMMIT'
                    ||detailData.status==='FINISH_MERCHANTS_AUDITED'||detailData.status==='FINISH_FINANCE_AUDITED'||detailData.status==='FINISH_AUDITED'
                    ||detailData.status==='FINISH_MERCHANTS_REJECT'||detailData.status==='FINISH_FINANCE_REJECT'||detailData.status==='FINISH_REJECT'
                    ?
                        <Form.Item label="退租日期：">
                            {getFieldDecorator('finishDate', {
                                rules: [{ required: true, message: '退租日期不能为空' }],
                                initialValue: finishDate == null || finishDate ==="" ? null : moment(finishDate)
                            })(
                                <DatePicker placeholder='选择日期' onChange={this.onDateChange} disabled={detailData.status==='FINISH_COMMIT'||detailData.status==='FINISH_MERCHANTS_AUDITED'||detailData.status==='FINISH_FINANCE_AUDITED'? true : false} style={{ width: '100%' }} />
                            )}
                        </Form.Item>
                    :""}
                </Form>
            </Modal>
        );
    }
}

class ContractAuditFailForm extends Component {
    state={
        finishDate:""
    }
    componentWillMount() {
        const {finishDate} = this.props
        this.setState({
            finishDate:finishDate
        })
    }
    failContract = () => {
        const form = this.props.form;
        const { detailData, url,finishDate} = this.props
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["id"] = detailData.id;
            if(this.state.finishDate!==""){
                values["finishDate"]=this.state.finishDate
            }else{
                values["finishDate"]=finishDate
            }
            http.post({
                url: url,
                data: { ...values },
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("退回成功！");
                }
            });
        });
    }

    onDateChange = (item, val) => {
        this.setState({
            finishDate:val
        })
    };

    render() {
        const { visible, onCancel, form ,detailData,finishDate} = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="退回合同"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.failContract}
                zIndex={1001}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
                    {detailData.status==='COMMIT'||detailData.status==='MERCHANTS_AUDITED'||detailData.status==='FINANCE_AUDITED'
                    ||detailData.status==='FINISH_COMMIT'||detailData.status==='FINISH_MERCHANTS_AUDITED'||detailData.status==='FINISH_FINANCE_AUDITED'
                    ?
                    <Form.Item label="退回意见">
                        {getFieldDecorator('remark', {
                            rules: [
                                { max: 256, message: '最多只能输入256个字符！' }],
                        })(
                            <Input.TextArea />
                        )}
                    </Form.Item>
                    :""}
                    {/* 退租流程才显示日期 */}
                    {detailData.status==='AUDITED'||detailData.status==='FINISH_COMMIT'||detailData.status==='FINISH_MERCHANTS_AUDITED'||detailData.status==='FINISH_FINANCE_AUDITED'||detailData.status==='FINISH_AUDITED'?
                        <Form.Item label="退租日期：">
                            {getFieldDecorator('finishDate', {
                                rules: [{ required: true, message: '退租日期不能为空' }],
                                initialValue: finishDate == null || finishDate ==="" ? null : moment(finishDate)
                            })(
                                <DatePicker placeholder='选择日期' onChange={this.onDateChange} disabled={detailData.status==='FINISH_COMMIT'||detailData.status==='FINISH_MERCHANTS_AUDITED'||detailData.status==='FINISH_FINANCE_AUDITED'? true : false} style={{ width: '100%' }} />
                            )}
                        </Form.Item>
                    :""}
                </Form>
            </Modal>
        );
    }
}
const ContractAuditFail = Form.create()(ContractAuditFailForm);
const ContractAuditSuccess = Form.create()(ContractAuditSuccessForm);


export default ContractManageDetail;